function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7717 2.71197C21.63 2.62735 21.4549 2.62404 21.3103 2.70352L16.2626 5.48211V2.34945C16.2611 1.05248 15.2186 0.00146841 13.9321 0H2.33051C1.044 0.00146841 0.00145657 1.05248 0 2.34945V14.6505C0.00145657 15.9475 1.044 16.9985 2.33051 17H13.9321C15.2186 16.9985 16.2611 15.9475 16.2626 14.6505V11.4547L21.3105 14.2333C21.4549 14.3127 21.6302 14.3096 21.7717 14.225C21.9133 14.1402 22 13.9866 22 13.8208V3.11596C22 2.95003 21.9132 2.79658 21.7717 2.71197ZM15.33 14.6507C15.3293 15.429 14.7037 16.0595 13.9317 16.0604H2.33051C1.55853 16.0595 0.933114 15.429 0.932203 14.6507V2.34945C0.933114 1.57138 1.55853 0.940698 2.33051 0.93978H13.9321C14.7039 0.940698 15.3295 1.57138 15.3304 2.34945L15.33 14.6507ZM21.0678 13.029L16.2626 10.384V6.55277L21.0678 3.90798V13.029Z",
  fill: "white"
});

function SvgCameraOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/camera-on.628e33d9.svg";
export { ForwardRef as ReactComponent };